import React, { useEffect, useReducer } from 'react'
import { AuthContext } from './auth/AuthContexts'
import { AppRouter } from './routers/AppRouter'
import { autReducer } from './auth/authReducer'

const init = () => {
    return JSON.parse(localStorage.getItem('user')) || { logged: false, }
    //este busca si esta el usuario en el local storage
    //si existe lo va a retornar  y si no va a ponner el logged en false
    //recuerda que eso es un or si se cumple ase algo y sino ase otra
}

export const HeroesApp = () => {

    const [user, dispatch] = useReducer(autReducer, {}, init);

    useEffect(() => {
        localStorage.setItem('user', JSON.stringify(user))
    }, [user])

    return (
        <div>

            <AuthContext.Provider value={{ user, dispatch }}>

                <AppRouter />

            </AuthContext.Provider>

        </div>
    )
}


//*el user y el dispach es lo que voy a distribuir a lo largo de la aplicacion